import { useMemo } from 'react';
import { useAppSelector } from '@/store/hooks';
import { selectThemePacks } from '@/store/slices/templates/selectors';
import { resolveEmailCampaignsThemePack } from './resolve-email-campaigns-theme-pack';

// see resolveEmailCampaignsThemePack
const useGetEmailCampaignsThemePack = (themeColorPackId: number | undefined) => {
  const themePacks = useAppSelector(selectThemePacks);

  return useMemo(() => resolveEmailCampaignsThemePack(themePacks, themeColorPackId), [themeColorPackId, themePacks]);
};

export default useGetEmailCampaignsThemePack;
